module.exports = function getResource(label, vars = []) {
    const resources = {
        title: 'Appliquer des récompenses Rouge',
        apply: 'Appliquer',
        applied: 'Appliqué',
        remove: 'Supprimer',
        rougeRewardsSubText: `${vars[0]} $ en récompenses Rouge`,
        rougeRewardsExpirationMessage: `Exp. ${vars[0]}`,
        done: 'Terminé'
    };

    return resources[label];
};
